/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatItem } from './StatItem';
import {
    StatItemFromJSON,
    StatItemFromJSONTyped,
    StatItemToJSON,
    StatItemToJSONTyped,
} from './StatItem';

/**
 * 
 * @export
 * @interface DomainThreatStats
 */
export interface DomainThreatStats {
    /**
     * 
     * @type {number}
     * @memberof DomainThreatStats
     */
    total: number;
    /**
     * 
     * @type {Array<StatItem>}
     * @memberof DomainThreatStats
     */
    byType: Array<StatItem>;
    /**
     * 
     * @type {Array<StatItem>}
     * @memberof DomainThreatStats
     */
    byStatus: Array<StatItem>;
    /**
     * 
     * @type {Array<StatItem>}
     * @memberof DomainThreatStats
     */
    byConfidence: Array<StatItem>;
}

/**
 * Check if a given object implements the DomainThreatStats interface.
 */
export function instanceOfDomainThreatStats(value: object): value is DomainThreatStats {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('byType' in value) || value['byType'] === undefined) return false;
    if (!('byStatus' in value) || value['byStatus'] === undefined) return false;
    if (!('byConfidence' in value) || value['byConfidence'] === undefined) return false;
    return true;
}

export function DomainThreatStatsFromJSON(json: any): DomainThreatStats {
    return DomainThreatStatsFromJSONTyped(json, false);
}

export function DomainThreatStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainThreatStats {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'byType': ((json['by_type'] as Array<any>).map(StatItemFromJSON)),
        'byStatus': ((json['by_status'] as Array<any>).map(StatItemFromJSON)),
        'byConfidence': ((json['by_confidence'] as Array<any>).map(StatItemFromJSON)),
    };
}

  export function DomainThreatStatsToJSON(json: any): DomainThreatStats {
      return DomainThreatStatsToJSONTyped(json, false);
  }

  export function DomainThreatStatsToJSONTyped(value?: DomainThreatStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'by_type': ((value['byType'] as Array<any>).map(StatItemToJSON)),
        'by_status': ((value['byStatus'] as Array<any>).map(StatItemToJSON)),
        'by_confidence': ((value['byConfidence'] as Array<any>).map(StatItemToJSON)),
    };
}

